import { Injectable, Signal, inject } from '@angular/core';
import { InvestigationAuthorizationState } from '../../states/investigation-authorization.state';

/**
 * Use case for reading the current user's investigation dashboard view type.
 * Returns the signal itself so callers can react to authorization loading,
 * which resolves after the first render. Emits null until state is loaded.
 */
@Injectable({ providedIn: 'root' })
export class GetInvestigationDashboardViewTypeUseCase {
  private readonly _state = inject(InvestigationAuthorizationState);

  public execute(): Signal<string | null> {
    return this._state.dashboardViewTypeName;
  }
}
